import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=73c7a683&scoped=true"
import script from "./Suspended.vue?vue&type=script&lang=js"
export * from "./Suspended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c7a683",
  null
  
)

export default component.exports